import { put, select } from 'redux-saga/effects';
import {
  loadPrimaryEmotionsBreakdownRequest, loadSentimentBreakdownRequest,
  loadTopWordsRequest
} from "../charts/charts-action-creators";
import {loadResponsesRequest} from "../responses/responses-action-creators";
import {loadWordVerbatimsRequest} from "../word-verbatims/word-verbatims-action-creators";
import {loadHbIndexChartDataRequest} from "../hb-index-chart/hb-index-chart-action-creators";

export default function* reloadData() {

  const reportUrl = yield select(state => state.report.reportUrl);
  const word = yield select(state => state.wordVerbatims.word);

  yield put(loadTopWordsRequest(reportUrl));
  yield put(loadSentimentBreakdownRequest(reportUrl));
  yield put(loadPrimaryEmotionsBreakdownRequest(reportUrl));
  yield put(loadResponsesRequest({page: 1, clean: true}));
  yield put(loadWordVerbatimsRequest(word));
  yield put(loadHbIndexChartDataRequest());
}


// WEBPACK FOOTER //
// ./src/modules/filters/reload-data-saga.js